module.exports = __webpack_public_path__ + "media/images/pages/youtube_white-422eeea5221d1fc23c1d54b198aab15a.png";